import { useEffect, useState } from "react";
import { getBusinessHoursForDate } from "../utilities/appointmentSlots";

export const useHours = (date) => {
  const [hoursObject, setHoursObject] = useState([]);

  useEffect(() => {
    setHoursObject(
      getBusinessHoursForDate(date).map((hour, index) => ({
        hour,
        index: index + 1,
      }))
    );

  }, [date])

  return { hoursObject }
}
